import {
  get,
  isString,
  map,
  template,
  omitBy,
  isNull,
  isNumber,
  isBoolean,
  isEmpty,
  find,
  compact,
  groupBy,
} from "utils/lodash";
import seoFormatter from "utils/seoFormatter";
import dayjs from "utils/dayjs";
import { formatPrice } from "./currencyFormatter";

// import { formatDateDisplay } from "./dateFormatter";
const helper = {
  normalizeParams: (object: any) =>
    omitBy(object, (val: any) => {
      return (
        val === "" ||
        val === undefined ||
        isNull(val) ||
        (!isNumber(val) && !isBoolean(val) && isEmpty(val))
      );
    }),
  interpolateContent: (content: any, attributes: any) => {
    return template(content, {
      interpolate: /{{([\s\S]+?)}}/g,
    })(attributes);
  },
  replaceAll: (str: string = "", find: string, replace: string) => {
    if (!isString(str)) return "";
    return str.split(find).join(replace);
  },
  isInternal: (to: string) => {
    return /^\/(?!\/)/.test(to);
  },
  isExternal: (val: string) => {
    return `${val}`.substring(0, 4) === "http";
  },
  copy: (val: string) => {
    navigator.clipboard.writeText(val);
  },
  formatMetatags: (pageData: any, metas?: any) => {
    return {
      title: seoFormatter.title(pageData),
      description: seoFormatter.description(pageData),
      keywords: seoFormatter.keywords(pageData),
      images: seoFormatter.image(pageData)
        ? [seoFormatter.image(pageData)]
        : [],
      url: seoFormatter.url(pageData) || "",
      openGraph: {
        title: seoFormatter.title(pageData),
        description: seoFormatter.description(pageData),

        url: seoFormatter.url(pageData) || "",
        images: seoFormatter.image(pageData)
          ? [seoFormatter.image(pageData)]
          : [],
      },
      twitter: {
        title: seoFormatter.title(pageData),
        description: seoFormatter.description(pageData),
        images: seoFormatter.image(pageData)
          ? [seoFormatter.image(pageData)]
          : [],
      },
      other: {
        image: seoFormatter.image(pageData),
      },
      icons: {
        icon: ["/favicon.ico?v=2"],
        apple: ["/apple-touch-icon.png?v=2"],
        shortcut: ["/apple-touch-icon.png?v=2"],
      },
      manifest: "/site.webmanifest",
      ...metas,
    };
  },

  sleep: (ms: number) => {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  },

  groupBookingsByTimeSlot({ bookings, shop, bookingDate }: any) {
    const dayOfWeek = dayjs(bookingDate).format("ddd").toLowerCase();
    const timeGap = get(
      find(get(shop, "bookingDayOfWeek"), (item: any) => {
        return item.dayOfWeek === dayOfWeek;
      }),
      "timeGap"
    );
    const parsedTimeGap = parseInt(timeGap?.replace("_", "") || "30");

    const grouped: any = {};
    map(bookings, (booking: any) => {
      const startTime = dayjs(booking.startTime);
      const endTime = dayjs(booking.startTime).add(parsedTimeGap, "minutes");
      const timeSlot = `${startTime.utcOffset(7).format("HH:mm")}-${endTime
        .utcOffset(7)
        .format("HH:mm")}`;
      if (!grouped[timeSlot]) {
        grouped[timeSlot] = [];
      }
      grouped[timeSlot].push(booking);
    });
    return grouped;
  },
  formatBooking: (booking: any) => {
    return {
      ...booking,
      shopId: get(booking, "shop.id"),
      customerNumber: get(booking, "customerNumber"),
      serviceTransaction: get(booking, "serviceTransaction"),
      date: get(booking, "bookingDate"),
      name: get(booking, "shop.name"),
      thumbnail: get(booking, "shop.avatar.url"),
    };
  },
  buildBillDetail: (booking: any) => {
    const serviceTransaction = get(booking, "serviceTransaction") || [];
    return map(serviceTransaction, (transaction: any) => {
      const campaignPackage = get(transaction, "campaignPackage", null);
      let itemCampaignPackage = null;
      const handler: any = {
        slot: (transaction: any) => {
          return {
            label: `Giảm giá khung giờ x 1`,
            price: `-${formatPrice(get(transaction, "discount"))}`,
          };
        },
        service: (transaction: any) => {
          return {
            label: `Giảm giá dịch vụ x 1`,
            price: `-${formatPrice(get(transaction, "discount"))}`,
          };
        },
      };
      if (campaignPackage) {
        itemCampaignPackage = handler[campaignPackage.type](transaction);
      }
      return {
        label: `${get(transaction, "service.name")} x ${get(
          transaction,
          "quantity"
        )}`,
        price: formatPrice(get(transaction, "service.menuPrice")),
        vouchers: compact([
          get(transaction, "voucher.code") && {
            label: `Mã giảm giá ${get(transaction, "voucher.code")} x 1`,
            price: `-${formatPrice(get(transaction, "discount"))}`,
          },
          itemCampaignPackage,
        ]),
      };
    });
  },
  formatListDays: (bookings: any) => {
    const grouped = groupBy(bookings, "bookingDate");
    return map(grouped, (bookings: any, bookingDate: any) => {
      return {
        bookingDate,
        bookings,
      };
    });
  },
  imageUrl: (item?: string | object) => {
    const url = isString(item) ? item : get(item, "url") || "";
    if (url === "" || url.includes(process.env.NEXT_PUBLIC_IMAGE_URL || ""))
      return url;
    return `${process.env.NEXT_PUBLIC_IMAGE_URL}${url}`;
  },
  getEmailName: (email?: string) => {
    return isString(email) ? email?.split("@")[0] || "" : "";
  },
};

export default helper;
